import React from "react";
import styled from "styled-components";
import COLORS from "common/Colors";

// Plain text (<p>) stand-in for ButtonLink within this module - same visual
// role (a clickable link-styled label) without rendering an actual <button>.
const StyledText = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  color: ${COLORS.PRIMARY};
  cursor: ${(props) => (props.$loading ? "default" : "pointer")};
  opacity: ${(props) => (props.$loading ? 0.6 : 1)};
  user-select: none;

  &:hover {
    text-decoration: ${(props) => (props.$loading ? "none" : "underline")};
  }
`;

const TextLink = ({ onClick, loading, children, ...rest }) => (
  <StyledText onClick={loading ? undefined : onClick} $loading={loading} {...rest}>
    {children}
  </StyledText>
);

export default TextLink;
